// Generated by `bazel run i18n`. Do not edit by hand.
import en from "./en/return-core-common.json";

export default en;
